import { Theme } from "../../../components/constants";

export default {
    customPopupStyles: {
        width: "90%",
        height: "95%",
        maxWidth: "none",
        top: "1%",
        left: "5%",
        transform: "none",
    },

    separatorLine: {
        margin: "22px 40px"
    },

    button: {
        minWidth: "140px",
        minHeight: "40px",
        fontWeight: "600"
    },

    icon: {
        width: "24px",
        height: "24px"
    },

    footer: {
        display: "flex",
        flexDirection: "row",
        alignItems: "flex-start",
        justifyContent: "flex-end",
        borderTop: `1px solid ${Theme.BORDER_PRIMARY}`,
        borderRadius: "0px 0px 8px 8px",
        columnGap: "12px",
        padding: "8px 40px 35px",
        position: "absolute",
        bottom: 0,
        left: 0,
        width: "100%",
        padding: "10px",
        borderTop: "1px solid #ccc",
    },
    cancelFooterButton: {
        background: Theme.SECONDARY_BACKGROUND,
        color: Theme.ACCORDION_TITLE_COLOR,
    },
    
}